var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "pipeline",
      staticClass: "drag-pipeline-columns",
      style: [
        _vm.moving && {
          border: "3px dotted rgb(163, 163, 170)",
          backgroundColor: "rgb(163 163 170 / 20%)",
          borderRadius: "8px",
        },
        { "--pipeline-color": _vm.pipeline.color },
        { "--pipeline-bg-color": _vm.taskBackgroundColor() },
      ],
      attrs: { id: _vm.pipeline._id },
    },
    [
      _c(
        "div",
        {
          staticClass: "drag-pipeline-column-head",
          style: {
            backgroundColor: _vm.taskBackgroundColor(),
            borderLeft: "7px solid " + (_vm.pipeline.color || "black"),
          },
          attrs: { type: _vm.pipeline.type },
        },
        [
          _c("div", { staticClass: "pipeline-head-content" }, [
            _c("div", { staticClass: "pipeline-details" }, [
              _c("div", { staticClass: "pipeline-detail" }, [
                _vm.pipeline.isNewColumn || _vm.editMode
                  ? _c(
                      "div",
                      { staticClass: "column-check" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pipeline-picker",
                            style: { "--row-color": _vm.pipeline.color },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("palette"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pipeline.color,
                                  expression: "pipeline.color",
                                },
                              ],
                              staticStyle: { opacity: "0" },
                              attrs: { type: "color" },
                              domProps: { value: _vm.pipeline.color },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.pipeline,
                                    "color",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("a-input", {
                          staticClass: "basic-task-input",
                          attrs: { placeholder: _vm.$t("task.writeSomething") },
                          model: {
                            value: _vm.pipeline.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.pipeline, "name", $$v)
                            },
                            expression: "pipeline.name",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "column-check" },
                      [
                        _c("a-checkbox", {
                          staticClass: "kanban-checkbox",
                          attrs: {
                            indeterminate: _vm.indeterminate,
                            checked: _vm.selected,
                          },
                          on: { change: _vm.checkedAllRows },
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.pipeline.name) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                !_vm.pipeline.isNewColumn && !_vm.editMode
                  ? _c(
                      "div",
                      { staticClass: "drag-pipeline-column-rows-length" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.pipeline.taskCount) +
                            " " +
                            _vm._s(_vm.$t("task.task")) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column-options" },
              [
                !_vm.pipeline.isNewColumn && !_vm.editMode
                  ? _c(
                      "a-popover",
                      {
                        attrs: {
                          overlayClassName: "task-more-options",
                          trigger: "click",
                          placement: "bottomRight",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm.isUpdatePermission
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "options-item",
                                    on: { click: _vm.openEditMode },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("edit")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("settings.edit")) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isDeletedColumn() && _vm.isDeletePermission
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "options-item",
                                    on: { click: _vm.deleteColumn },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("delete")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("chatbotv2.delete")) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "column-options" }, [
                          _c(
                            "div",
                            { staticClass: "task-more material-icons" },
                            [_vm._v("more_vert")]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pipeline.isNewColumn || _vm.editMode
                  ? _c(
                      "div",
                      {
                        staticClass: "column-options",
                        on: { click: _vm.createPipeline },
                      },
                      [
                        _c("div", { staticClass: "task-more material-icons" }, [
                          _vm._v("check"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pipeline.isNewColumn || _vm.editMode
                  ? _c(
                      "div",
                      {
                        staticClass: "column-options",
                        on: { click: _vm.deletePipeline },
                      },
                      [
                        _c("div", { staticClass: "task-more material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.pipeline.isNewColumn &&
                !_vm.editMode &&
                _vm.isCreatePermission &&
                _vm.pipeline.type !== "completed"
                  ? _c(
                      "div",
                      {
                        staticClass: "column-options",
                        on: {
                          click: function ($event) {
                            _vm.$feature.beforeCreateTaskColumn(
                              _vm.addNewColumn,
                              _vm.getPipelineCount()
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "task-more material-icons" }, [
                          _vm._v("add"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          !_vm.pipeline.isNewColumn && !_vm.editMode
            ? _c("div", { staticClass: "basic-task-container" }, [
                _vm.isCreatePermission
                  ? _c(
                      "div",
                      {
                        staticClass: "basic-task-add",
                        on: {
                          click: function ($event) {
                            _vm.$feature.beforeCreateTaskRow(function () {
                              return _vm.createTaskForm("external")
                            }, _vm.pipeline.taskCount)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" add "),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isTaskFormActive("external")
        ? _c("BasicTask", {
            attrs: {
              pipelineStageId: _vm.pipeline._id,
              "workflow-id": _vm.workflowId,
            },
            on: {
              close: function () {
                return _vm.closeTaskForm("external")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.pipeline.isNewColumn
        ? _c(
            "draggable",
            {
              key: _vm.pipeline._id,
              ref: "pipeline",
              staticClass: "supsis-draggable-card",
              attrs: {
                options: _vm.groupTaskItemDragOptions,
                id: _vm.pipeline._id,
                group: "tasks",
              },
              on: { end: _vm.moveActionEnd },
              model: {
                value: _vm.pipeline.tasks,
                callback: function ($$v) {
                  _vm.$set(_vm.pipeline, "tasks", $$v)
                },
                expression: "pipeline.tasks",
              },
            },
            [
              _c(
                "transition-group",
                {
                  staticClass: "drag-pipeline-rows",
                  attrs: {
                    name: "fade",
                    tag: "div",
                    id: "" + _vm.pipeline._id,
                  },
                },
                [
                  _vm._l(_vm.pipeline.tasks, function (task) {
                    return _c("TaskCard", {
                      key: task._id,
                      staticClass: "task-card",
                      attrs: {
                        item: task,
                        pipeline: _vm.pipeline,
                        "workflow-id": _vm.workflowId,
                      },
                      on: {
                        "delete-item": _vm.deleteTaskModalOpen,
                        "confirm-item": _vm.confirmModelOpen,
                        "archived-item": _vm.archivedTask,
                        "change-workflow": _vm.changeWorkflow,
                        "to-completed": _vm.toCompleted,
                      },
                    })
                  }),
                  _vm._v(" "),
                  !_vm.isTaskFormActive("internal") &&
                  !_vm.pipeline.isNewColumn &&
                  !_vm.editMode &&
                  _vm.isCreatePermission
                    ? _c(
                        "div",
                        {
                          key: "add-button-inside",
                          staticClass: "basic-task-add no-drag",
                          on: {
                            click: function ($event) {
                              _vm.$feature.beforeCreateTaskRow(function () {
                                return _vm.createTaskForm("internal")
                              }, _vm.pipeline.taskCount)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "8px" } },
                            [_vm._v("Konu Oluştur")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTaskFormActive("internal")
                    ? _c("BasicTask", {
                        key: "basic-task-form",
                        staticClass: "no-drag",
                        attrs: {
                          pipelineStageId: _vm.pipeline._id,
                          "workflow-id": _vm.workflowId,
                        },
                        on: {
                          close: function () {
                            return _vm.closeTaskForm("internal")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteColumnModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteColumnCont"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteColumnModal = false
              },
              confirm: function ($event) {
                return _vm.deletePipelineFn(false)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteTransportModal
        ? _c(
            "DeleteModal",
            {
              attrs: { modalBtnVisible: false },
              on: {
                cancel: function ($event) {
                  _vm.deleteTransportModal = false
                },
              },
            },
            [
              _vm.transportTaskBtn
                ? _c(
                    "div",
                    [
                      _c(
                        "a-button",
                        {
                          key: "submit",
                          attrs: { type: "danger" },
                          on: { click: _vm.transportColumnVisibility },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("task.moveAndDeleteTask")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          key: "submit",
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deletePipelineFn(true)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("task.justDelete")) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.transportTaskNewColumn
                ? _c(
                    "div",
                    { staticClass: "kanban-task-transport-select" },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("task.selectColumnMoveTask"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticClass: "classic-new-select",
                          staticStyle: {
                            "margin-bottom": "10px",
                            width: "200px",
                          },
                          model: {
                            value: _vm.newTaskPositionId,
                            callback: function ($$v) {
                              _vm.newTaskPositionId = $$v
                            },
                            expression: "newTaskPositionId",
                          },
                        },
                        _vm._l(_vm.defaultWorkflow.pipeline, function (item) {
                          return _c(
                            "a-select-option",
                            { key: item._id, attrs: { value: item._id } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.name) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          key: "submit",
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deletePipelineFn(true)
                            },
                          },
                        },
                        [_vm._v("Sil")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }